<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="700"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <div class="bind-tip">为门店「{{ storeName }}」绑定收银员，绑定后收银员可在独立收银端使用该门店</div>
        <a-transfer
          :data-source="userDataSource"
          :target-keys="targetKeys"
          :render="renderItem"
          :titles="['未绑定', '已绑定']"
          :list-style="{ width: '250px', height: '320px' }"
          show-search
          :filter-option="filterOption"
          @change="handleTransferChange" />
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { getUserList } from '@/api/api'
import { storeUsers, storeBindUsers } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'DiningStoreUsersModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '收银员绑定',
      visible: false,
      confirmLoading: false,
      store: {},
      userDataSource: [],
      targetKeys: []
    }
  },
  computed: {
    storeName() {
      return (this.store && this.store.name) || ''
    }
  },
  methods: {
    show(record) {
      this.store = Object.assign({}, record)
      this.targetKeys = []
      this.visible = true
      this.loadUsers()
    },
    // 本租户用户列表（GET /user/getUserList，返回 [{id, userName}]）
    loadUsers() {
      getUserList({}).then(res => {
        const list = Array.isArray(res) ? res : []
        this.userDataSource = list.map(u => ({ key: u.id, id: u.id, userName: u.userName }))
        this.loadBound()
      })
    },
    // 门店已绑定收银员（GET /store/{id}/users）
    loadBound() {
      storeUsers(this.store.id).then(res => {
        if (res.code === 200) {
          this.targetKeys = (res.data || []).map(u => u.id)
        }
      })
    },
    renderItem(item) {
      return item.userName
    },
    filterOption(inputValue, item) {
      return item.userName.indexOf(inputValue) > -1
    },
    handleTransferChange(targetKeys) {
      this.targetKeys = targetKeys
    },
    // 保存：整体替换绑定（PUT /store/{id}/users，body.userIds）
    handleOk() {
      const that = this
      that.confirmLoading = true
      storeBindUsers(this.store.id, { userIds: this.targetKeys }).then(res => {
        if (res.code === 200) {
          that.$message.success(res.message)
          that.$emit('ok')
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.confirmLoading = false
        that.close()
      })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
<style scoped>
.bind-tip {
  margin-bottom: 14px;
  color: #666;
  font-size: 13px;
}
</style>
